import { Stack } from 'expo-router';

export default function ArticleStructureLayout() {
    return <Stack screenOptions={{ headerShown: false }} />;
}
